import * as React from 'react';
import { ColumnItemsProvider } from './logic/ColumnItemsProvider';
import { observer } from 'mobx-react-lite';

let styles = require('./SurfaceTemplates.scss');

/**
 * This file defines internal templates we are not exposing to consumers
 * Use Templates.tsx for templates exposed to consumer
 */

/**
 * Creates column with content
 * @param key the React key
 * @param content The content
 */
export function column(
    key: string,
    content: () => JSX.Element[],
    style: React.CSSProperties
): JSX.Element {
    return (
        <div key={key} className={styles.column} style={style}>
            <ColumnContent content={content} />
        </div>
    );
}

/**
 * Creates all day panel with content
 * @param key the React key
 * @param itemsProvider The provider of content items
 * @param content The content
 */
export function allDayPanel(
    key: string,
    itemsProvider: ColumnItemsProvider,
    content: () => JSX.Element[]
): JSX.Element {
    return <AllDayPanel key={key} itemsProvider={itemsProvider} content={content} />;
}

interface ColumnContentProps {
    content: () => JSX.Element[];
}

const ColumnContent = observer(function ColumnContent(props: ColumnContentProps) {
    let { content } = props;
    return <div className={styles.content}>{content && content()}</div>;
});

interface AllDayPanelProps extends ColumnContentProps {
    itemsProvider: ColumnItemsProvider;
}

const AllDayPanel = observer(function AllDayPanel(props: AllDayPanelProps) {
    let { itemsProvider, content } = props;
    let numberOfAllDayRows = itemsProvider.allDayRows.length;
    let allDayWellPadding = 8;
    let style = {
        // We define a fixed height for each all day item and then
        // add 8px padding at the bottom of all day well'd height.
        height: numberOfAllDayRows
            ? numberOfAllDayRows * 30 + allDayWellPadding
            : numberOfAllDayRows,
    };
    return (
        <div className={styles.allDayPanel} style={style}>
            {content && content()}
        </div>
    );
});
